var React = require('react');

function CursorDefaultInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.1865 31.231L30.9279 23.606L16.1146 15.3034L19.1865 31.231Z","fill":"#FF00FF"}));
}

CursorDefaultInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CursorDefaultInline;

CursorDefaultInline.default = CursorDefaultInline;
